import React from "react";
import type { FormikProps } from "formik";
import ValidatedForm from "../../../../components/forms/ValidatedForm";
import nameof from "utils/nameof";
import { type EmailSetting } from "../../types";
import styles from "./ThreatDefense.module.scss";
import { Typography } from "components/common/Typography/Typography";

interface SmtpConfigurationFormProps {
  formik: FormikProps<Partial<EmailSetting>>;
  canEdit: boolean;
  credentialsRequired: boolean;
  resetVerify: () => void;
}

export const SmtpConfigurationForm = ({
  formik,
  canEdit,
  credentialsRequired,
  resetVerify,
}: SmtpConfigurationFormProps) => {
  const { senderName, senderEmail, userName, password, host, port, isSsl } = formik.values;

  return (
    <>
      <br />
      <br />
      <Typography className={styles["email-settings-header"]} bold variant="title2">
        SENDER INFORMATION
      </Typography>
      <ValidatedForm.InputField
        markAsRequired
        disabled={!canEdit}
        label="Default Sender Name"
        value={senderName}
        propertyName={nameof<EmailSetting>("senderName")}
        placeholder="Enter Sender Name"
        onValueChanged={resetVerify}
        {...formik}
      />
      <ValidatedForm.InputField
        markAsRequired
        disabled={!canEdit}
        label="Default Sender Email"
        value={senderEmail}
        propertyName={nameof<EmailSetting>("senderEmail")}
        placeholder="Enter Sender Email"
        onValueChanged={resetVerify}
        {...formik}
      />
      <br />
      <br />
      <Typography className={styles["email-settings-header"]} bold variant="title2">
        CONFIGURE SERVER
      </Typography>
      <ValidatedForm.InputField
        markAsRequired
        disabled={!canEdit}
        label="Host"
        value={host}
        propertyName={nameof<EmailSetting>("host")}
        placeholder="mail.domain.com"
        onValueChanged={resetVerify}
        {...formik}
      />
      <ValidatedForm.InputField
        markAsRequired
        disabled={!canEdit}
        label="Port"
        value={port || ""}
        propertyName={nameof<EmailSetting>("port")}
        placeholder="E.g. 25"
        onValueChanged={resetVerify}
        {...formik}
      />
      <ValidatedForm.CheckboxField
        toggle
        disabled={!canEdit}
        propertyName={nameof<EmailSetting>("isSsl")}
        value={isSsl}
        label={"Use SSL"}
        {...formik}
        handleChange={resetVerify}
      />
      <ValidatedForm.InputField
        label="Username"
        disabled={!canEdit}
        value={userName}
        propertyName={nameof<EmailSetting>("userName")}
        placeholder="Enter Username"
        markAsRequired={credentialsRequired}
        autoComplete={"off"}
        onValueChanged={resetVerify}
        {...formik}
      />
      <ValidatedForm.InputField
        label="Password"
        disabled={!canEdit}
        value={password}
        propertyName={nameof<EmailSetting>("password")}
        placeholder="Enter Password"
        inputType="password"
        markAsRequired={credentialsRequired}
        autoComplete={"off"}
        onValueChanged={resetVerify}
        {...formik}
      />
      <br />
      <br />
    </>
  );
};
